import React from 'react';
import ArticlesInstagramPage from 'src/modules/articles/instagram/components/page/ArticlesInstagramPage';
import { wrapper } from 'src/store';
import { fetchPageData, PageKeys } from 'src/modules/pages';

const InstagramIndex: React.FunctionComponent = () => {
  return <ArticlesInstagramPage />;
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ store }) => {
  await fetchPageData(PageKeys.InstagramOverview)(store.dispatch, store.getState);
});

export default InstagramIndex;
